/* =================================================================
   YHSWAGY — RECENT SEARCHES

   Stores the last few search terms in localStorage and renders them
   in the search panel's left rail, above Popular searches.

   Defined as a custom element so it survives the Section Rendering
   API: custom elements upgrade automatically when inserted into the
   DOM, which a plain inline <script> would not.
   ================================================================= */

(() => {
  const KEY = 'yhs:recent-searches';
  const MAX = 5;

  const read = () => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  };

  const write = (terms) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(terms.slice(0, MAX)));
    } catch (e) {
      /* private mode or quota full — recent searches just won't persist */
    }
  };

  const refreshAll = () => {
    document.querySelectorAll('yhs-recent-searches').forEach((el) => {
      if (typeof el.render === 'function') el.render();
    });
  };

  const remember = (term) => {
    const clean = (term || '').trim();
    if (clean.length < 2) return;
    const terms = read().filter((t) => t.toLowerCase() !== clean.toLowerCase());
    terms.unshift(clean);
    write(terms);
    refreshAll();
  };

  /* ---------- Capture ---------- */

  // Any search form submission
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    const field = form.querySelector('input[name="q"]');
    if (field) remember(field.value);
  });

  // Enter pressed inside a predictive-search input
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const field = event.target;
    if (!field || field.name !== 'q') return;
    remember(field.value);
  });

  // Landing on a search results page
  const onLoad = () => {
    const q = new URLSearchParams(window.location.search).get('q');
    if (q) remember(q);
    refreshAll();
  };

  /* ---------- The element ---------- */

  class YhsRecentSearches extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-yhs-clear]')) {
          event.preventDefault();
          write([]);
          this.render();
        }
      });
      this.render();
    }

    render() {
      const list = this.querySelector('[data-yhs-recent-list]');
      if (!list) return;

      const terms = read();
      if (!terms.length) {
        this.hidden = true;
        list.innerHTML = '';
        return;
      }

      this.hidden = false;
      list.innerHTML = terms
        .map((term) => {
          const safe = term
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
          return (
            '<li><a class="yhs-rail__link" href="/search?q=' +
            encodeURIComponent(term) +
            '">' +
            safe +
            '</a></li>'
          );
        })
        .join('');
    }
  }

  if (!customElements.get('yhs-recent-searches')) {
    customElements.define('yhs-recent-searches', YhsRecentSearches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();
